module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "4px 0px"
    }
  }, [(this.$props['labelSize'] != 'L') ? _c('div', {
    staticClass: "col-xs-1"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.labelClass,
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('label', {
    staticClass: "control-label lams_inventory_form_label"
  }, [_vm._v(_vm._s(_vm.fieldLabel))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-5"
  }, [_c('input', {
    staticClass: "lams_inventory_form_control",
    staticStyle: {
      "text-align": "end"
    },
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": _vm.fieldValue
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42b5dd50","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fields/input-box-result.vue
// module id = 971
// module chunks = 0